export default "__VITE_ASSET__bdd66ca3__"